var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJardinprivado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3392_14314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.207 13.3633V17.3633",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2346 4.19721C15.0265 3.55845 14.6217 3.00189 14.0781 2.60722C13.5344 2.21255 12.8799 2 12.2081 2C11.5363 2 10.8817 2.21255 10.3381 2.60722C9.79444 3.00189 9.38962 3.55845 9.18157 4.19721C8.50966 4.19751 7.85509 4.41043 7.31159 4.80546C6.76808 5.2005 6.36353 5.7574 6.15585 6.3964C5.94818 7.0354 5.94805 7.72373 6.15546 8.36281C6.36288 9.0019 6.76722 9.55895 7.31057 9.95421C7.10361 10.5933 7.10412 11.2815 7.31203 11.9203C7.51995 12.5591 7.9246 13.1157 8.46809 13.5105C9.01158 13.9054 9.66604 14.1182 10.3378 14.1185C11.0096 14.1188 11.6642 13.9066 12.2081 13.5122C12.7518 13.9069 13.4066 14.1194 14.0785 14.1193C14.7504 14.1192 15.4051 13.9064 15.9487 13.5114C16.4923 13.1165 16.897 12.5597 17.1048 11.9207C17.3126 11.2817 17.3129 10.5934 17.1056 9.95421C17.6489 9.55895 18.0532 9.0019 18.2607 8.36281C18.4681 7.72373 18.4679 7.0354 18.2603 6.3964C18.0526 5.7574 17.648 5.2005 17.1045 4.80546C16.561 4.41043 15.9065 4.19751 15.2346 4.19721Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.207 6.36328C12.7375 6.36328 13.2462 6.57399 13.6212 6.94907C13.9963 7.32414 14.207 7.83285 14.207 8.36328C14.207 8.89371 13.9963 9.40242 13.6212 9.77749C13.2462 10.1526 12.7375 10.3633 12.207 10.3633C11.6766 10.3633 11.1679 10.1526 10.7928 9.77749C10.4177 9.40242 10.207 8.89371 10.207 8.36328C10.207 7.83285 10.4177 7.32414 10.7928 6.94907C11.1679 6.57399 11.6766 6.36328 12.207 6.36328Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.22283 18.2906C6.27983 17.7106 6.82783 17.4116 7.41133 17.4006C9.01001 17.3731 10.6089 17.3606 12.2078 17.3631C14.5558 17.3631 16.1158 17.3836 17.0043 17.4006C17.5878 17.4116 18.1358 17.7106 18.1923 18.2906C18.2134 18.5051 18.2134 18.7211 18.1923 18.9356C18.1368 19.5051 17.6078 19.8031 17.0373 19.8246C16.9482 20.2568 16.8518 20.6876 16.7483 21.1166C16.4963 22.1546 15.6018 22.8211 14.5343 22.8431C13.9568 22.8546 13.1978 22.8631 12.2078 22.8631C11.2178 22.8631 10.4593 22.8546 9.88133 22.8431C8.81383 22.8211 7.91933 22.1546 7.66733 21.1166C7.56399 20.6876 7.46781 20.2568 7.37883 19.8246C6.80783 19.8031 6.27883 19.5051 6.22283 18.9356C6.20177 18.7211 6.20177 18.5051 6.22283 18.2906Z",
    stroke: "#2B363D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3392_14314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJardinprivado);
export default __webpack_public_path__ + "static/media/Jardin privado.b00541ec1093bde556a869720435b0bf.svg";
export { ForwardRef as ReactComponent };